import { Head, Html } from '@react-email/components';
import generateInlineCSS from '@Utils/inlineStyles';
import i18next from 'i18next';

const html = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        const globalStyles = element?.globalStyles || {};
        const inlineStyles = generateInlineCSS(globalStyles);

        return (
            <div
                {...attributes}
                {...element.attributes}
                dir={i18next.dir(element.attributes.lang)}
            >
                <style>{inlineStyles}</style>
                {children}
            </div>
        );
    },
    PreviewElement: ({ node, attributes, children }) => {
        const globalStyles = node?.globalStyles || {};

        return (
            <Html {...attributes} dir={i18next.dir(attributes.lang)}>
                <Head>
                    <style type="text/css">
                        {generateInlineCSS(globalStyles)}
                    </style>
                </Head>
                {children}
            </Html>
        );
    },
};

export default html;
